/**
 * TypeScript event type definitions for RondevuConnection
 */
export var ConnectionState;
(function (ConnectionState) {
    ConnectionState["INITIALIZING"] = "initializing";
    ConnectionState["GATHERING"] = "gathering";
    ConnectionState["SIGNALING"] = "signaling";
    ConnectionState["CHECKING"] = "checking";
    ConnectionState["CONNECTING"] = "connecting";
    ConnectionState["CONNECTED"] = "connected";
    ConnectionState["DISCONNECTED"] = "disconnected";
    ConnectionState["RECONNECTING"] = "reconnecting";
    ConnectionState["FAILED"] = "failed";
    ConnectionState["CLOSED"] = "closed";
})(ConnectionState || (ConnectionState = {}));
